import { render } from "./property-mortgage.vue?vue&type=template&id=a0c95288"
import script from "./property-mortgage.js?vue&type=script&lang=js"
export * from "./property-mortgage.js?vue&type=script&lang=js"

import "./property-mortgage.vue?vue&type=style&index=0&id=a0c95288&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__